import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import {
  BehaviorInputData,
  FidelityReviewSection,
  FormEventEmit,
} from '../../../fidelity.interface';
import { CorrectionNeededFormComponent } from '../correction-needed-form/correction-needed-form.component';

@Component({
  selector: 'app-correction-needed-data',
  standalone: true,
  imports: [CorrectionNeededFormComponent],
  templateUrl: './correction-needed-data.component.html',
})
export class CorrectionNeededDataComponent implements OnChanges {
  @Input() fidelityData: BehaviorInputData | null = null;
  @Output() formValueChange = new EventEmitter<FormEventEmit>();

  enteredData: FidelityReviewSection | null = null;
  ngOnChanges(): void {
    if (this.fidelityData) {
      this.enteredData = this.fidelityData.fidelityData?.data ?? null;
    }
  }
}
